import Layout from 'components/Layout';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import SMETpl from 'templates/SMETpl';

const Tpl = props => (
  <Layout location={props.location} customizedHeader="sme">
    <SMETpl {...props} />
  </Layout>
);
const SME = props => {
  const data = useStaticQuery(graphql`
    query SmeQuery {
      SMEPages: smeJson {
        title
        meta {
          description
        }
        ctaLink
        banner {
          heading
          subheading
        }
        check {
          heading
          list
        }
        features {
          heading
          content {
            heading
            list {
              img {
                publicURL
              }
              text
            }
          }
        }
        videos {
          heading
          url
        }
        customers {
          heading
          subheading
        }
        benefit {
          heading
          subheading
          list1
          list2
        }
        pricingInfo {
          heading
          info
        }
        QA {
          q
          a
        }
      }
      caseSelected: allCaseJson(
        limit: 4,
        filter: { id: { in: ["1", "2", "5", "8"] } }
      ) {
        nodes {
          slug
          title
          coverImage {
            publicURL
          }
          company {
            displayName
            logoImage {
              publicURL
            }
          }
        }
      }
    }
  `);
  return (<Tpl data={data} {...props} />);
};

Tpl.propTypes = {
  location: PropTypes.object,
};

export default SME;
